module.exports = __webpack_public_path__ + "img/remove.18154f20.svg";